<template>
    <div
      class="dropzone"
      :class="{ drag: isDragging, has: !!selectedFile }"
      @dragenter.prevent="onDragEnter"
      @dragover.prevent="onDragOver"
      @dragleave.prevent="onDragLeave"
      @drop.prevent="onDrop"
      @click="$emit('pick')"
    >
      <div v-if="!selectedFile" class="dz-empty">
        <div class="icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M12 16V8m0 0 3 3m-3-3-3 3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M20 16.5a4 4 0 0 0-3.5-3.97A5 5 0 0 0 7.2 10.2 3.5 3.5 0 0 0 4 13.65 3.5 3.5 0 0 0 7.5 17H16"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <div class="t1">拖拉 PDF 到這裡或點一下上傳</div>
        <div class="t2">純前端 OCR / 不上傳</div>
      </div>
  
      <div v-else class="dz-has">
        <div class="file">
          <div class="name">{{ selectedFile.name }}</div>
          <div class="meta">{{ prettySize(selectedFile.size) }}</div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup lang="ts">
  const props = defineProps<{ selectedFile: File | null }>()
  const emit = defineEmits<{
    (e: 'pick'): void
    (e: 'filePicked', f: File): void
  }>()
  
  const isDragging = defineModel<boolean>('isDragging', { default: false })
  
  function onDragEnter() { isDragging.value = true }
  function onDragOver() { isDragging.value = true }
  function onDragLeave() { isDragging.value = false }
  
  function onDrop(ev: DragEvent) {
    isDragging.value = false
    const f = ev.dataTransfer?.files?.[0]
    if (!f) return
    if (f.type !== 'application/pdf') return
    emit('filePicked', f)
  }
  
  function prettySize(bytes: number) {
    const units = ['B','KB','MB','GB']
    let v = bytes
    let i = 0
    while (v >= 1024 && i < units.length - 1) { v /= 1024; i++ }
    return `${v.toFixed(i === 0 ? 0 : 2)} ${units[i]}`
  }
  </script>
  
  <style scoped lang="scss">
  .dropzone {
    margin: 12px;
    border: 1.5px dashed rgba(255,255,255,0.18);
    border-radius: 16px;
    padding: 12px;
    cursor: pointer;
    transition: 0.2s ease;
    background: rgba(255,255,255,0.03);
  
    &.drag {
      border-color: rgba(29,123,255,0.85);
      box-shadow: 0 0 0 4px rgba(29,123,255,0.15);
    }
  
    .dz-empty {
      display: grid;
      justify-items: center;
      gap: 8px;
      padding: 14px 8px;
  
      .icon {
        width: 54px;
        height: 54px;
        border-radius: 999px;
        display: grid;
        place-items: center;
        color: #1d7bff;
        background: rgba(29,123,255,0.16);
        svg { width: 28px; height: 28px; }
      }
      .t1 { font-weight: 700; font-size: 13px; text-align: center; }
      .t2 { font-size: 12px; color: rgba(232,238,252,0.6); }
    }
  
    .dz-has {
      .file .name { font-weight: 700; font-size: 13px; }
      .file .meta { font-size: 12px; color: rgba(232,238,252,0.6); margin-top: 4px; }
    }
  }
  </style>
  